import React from 'react';

export const GoogleMap = ({ lat = 48.207438, lng = -2.563914 }) => {
  // For demo purposes, showing a static map with reduced zoom level
  const staticMapUrl = `https://www.google.com/maps?q=${lat},${lng}&z=12&output=embed`;
  
  return (
    <div className="w-full h-64 rounded-xl overflow-hidden shadow-lg mt-4">
      <iframe
        src={staticMapUrl}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Domaine de Launay Guen, Plémet"
      />
    </div>
  );
};